import { Container } from "./styled";

const payments = [
  {
    name: "",
    amount: 25000,
    date: "2021-02-08 13:41:44",
  },
];

export const PaymentsHistoryPage = () => {
  return (
    <Container>
      <table>
        <tbody>
          {payments.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{item.amount}</td>
              <td>{item.date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
};
